import dark from "../Assets/images/map-dark.png";
import light from "../Assets/images/map-light.png";
import outdoors from "../Assets/images/outdoors.png";
import satellite from "../Assets/images/satellite.png";
import streets from "../Assets/images/streets.png";

export const Month = [
  { id: 1, name: "January", value: 1 },
  { id: 2, name: "February", value: 2 },
  { id: 3, name: "March", value: 3 },
  { id: 4, name: "April", value: 4 },
  { id: 5, name: "May", value: 5 },
  { id: 6, name: "June", value: 6 },
  { id: 7, name: "July", value: 7 },
  { id: 8, name: "August", value: 8 },
  { id: 9, name: "September", value: 9 },
  { id: 10, name: "October", value: 10 },
  { id: 11, name: "November", value: 11 },
  { id: 12, name: "December", value: 12 },
  { id: 13, name: "Annual", value: 13 },
];

export const styles = [
  {
    id: "streets",
    icon: streets,
    style: "mapbox://styles/mapbox/streets-v9",
  },
  {
    id: "satellite",
    icon: satellite,
    style: "mapbox://styles/mapbox/satellite-streets-v9",
  },
  { id: "dark", icon: dark, style: "mapbox://styles/mapbox/dark-v9" },
  { id: "light", icon: light, style: "mapbox://styles/mapbox/light-v9" },
  {
    id: "outdoors",
    icon: outdoors,
    style: "mapbox://styles/mapbox/outdoors-v9",
  },
];

export const globeStyles = [
  {
    id: "streets",
    icon: streets,
    name: "streets"
  },
  {
    id: "satellite",
    icon: satellite,
    name: "satellite-streets"
  },
  { id: "dark", icon: dark, name: "dark" },
  { id: "light", icon: light, name: "light" },
  {
    id: "outdoors",
    icon: outdoors,
    name: "outdoors"
  },
];
